import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';

// @mui
import { styled } from '@mui/material/styles';
import { Container, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// components
import Logo from '../components/logo';
// sections
import SignupForm from '../sections/SignupForm';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function SignupPage() {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>BillerBay | Sign Up</title>
      </Helmet>

      <StyledRoot>
        <Logo
          sx={{
            position: 'fixed',
            top: { xs: 16, sm: 24, md: 40 },
            left: { xs: 16, sm: 24, md: 40 },
          }}
        />

        <Container maxWidth="sm">
          <StyledContent>
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
              <IconButton onClick={() => navigate('/login')}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h4">Sign Up</Typography>
            </div>

            <Typography gutterBottom>
              Enter the details to create your account. The temporary password will be sent to your email address.
            </Typography>

            <SignupForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
